import React, {PropsWithChildren, useContext} from "react";
import {ServerDataContext} from "./ServerDataContext";
import {FileSection} from "../models/file.model";

export const FileContext = React.createContext({} as FileSection);

export const FileProvider: React.FunctionComponent<PropsWithChildren> = ({children}) => {
    const data = useContext(ServerDataContext);

    return (
        <FileContext.Provider value={data.fileSection}>
            {children}
        </FileContext.Provider>
    )
}